(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-image-carousel"] && !Shopify.designMode) return;
  try {
    
  class CustomImageCarousel {
    constructor(sectionEl) {
      this.section = sectionEl;
      this.rail = this.section.querySelector('.cic-rail');
      this.prevButton = this.section.querySelector('.cic-nav-button--prev');
      this.nextButton = this.section.querySelector('.cic-nav-button--next');
      this.isDragging = false;
      this.startX = 0;
      this.scrollLeft = 0;
      
      this.init();
    }

    init() {
      // ✨ NEW: Animation observer logic added
      this.initAnimationObserver();
      
      if (!this.rail) return;
      
      this.bindEvents();
      this.checkNavButtons();
    }
    
    // ✨ NEW: Method to handle scroll-triggered animation
    initAnimationObserver() {
      const options = {
        rootMargin: '0px 0px -100px 0px', // Trigger a little before it's fully in view
        threshold: 0.1
      };
      
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.section.classList.add('is-visible');
            observer.unobserve(this.section); // Animate only once
          }
        });
      }, options);

      observer.observe(this.section);
    }

    bindEvents() {
      this.prevButton.addEventListener('click', this.onPrevClick.bind(this));
      this.nextButton.addEventListener('click', this.onNextClick.bind(this));
      this.rail.addEventListener('scroll', this.checkNavButtons.bind(this));
      
      this.rail.addEventListener('mousedown', (e) => {
        this.isDragging = true;
        this.rail.style.cursor = 'grabbing';
        this.startX = e.pageX - this.rail.offsetLeft;
        this.scrollLeft = this.rail.scrollLeft;
      });
      
      this.rail.addEventListener('mouseleave', () => { this.isDragging = false; this.rail.style.cursor = 'grab'; });
      this.rail.addEventListener('mouseup', () => { this.isDragging = false; this.rail.style.cursor = 'grab'; });

      this.rail.addEventListener('mousemove', (e) => {
        if (!this.isDragging) return;
        e.preventDefault();
        const x = e.pageX - this.rail.offsetLeft;
        const walk = (x - this.startX) * 1.5;
        this.rail.scrollLeft = this.scrollLeft - walk;
      });
    }

    getScrollStep() {
      const card = this.rail.querySelector('.cic-card');
      if (!card) return 0;
      return card.offsetWidth + parseInt(getComputedStyle(this.rail).gap, 10);
    }
    
    onPrevClick() { this.rail.scrollBy({ left: -this.getScrollStep() * 2, behavior: 'smooth' }); }
    onNextClick() { this.rail.scrollBy({ left: this.getScrollStep() * 2, behavior: 'smooth' }); }

    checkNavButtons() {
      const tolerance = 2;
      const maxScroll = this.rail.scrollWidth - this.rail.clientWidth;
      this.prevButton.disabled = this.rail.scrollLeft <= tolerance;
      this.nextButton.disabled = this.rail.scrollLeft >= maxScroll - tolerance;
    }
  }

  document.querySelectorAll('[data-section-id]').forEach(sectionEl => {
    if (sectionEl.id.startsWith('c-img-c-')) {
      new CustomImageCarousel(sectionEl);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
